var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-filled",class:[_vm.isFullWidth ? 'full-width' : null]},[_c('div',{staticClass:"button",on:{"click":function($event){return _vm.onClick()}}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }